import { render, staticRenderFns } from "./BaseMoney.vue?vue&type=template&id=1e9cc630"
import script from "./BaseMoney.vue?vue&type=script&lang=js"
export * from "./BaseMoney.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports